import script from "./WizardShell.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardShell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SecondaryNav from "@/components/SecondaryNav.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardRail from "@/components/neue/wizard/WizardRail.vue";
script.components = Object.assign({}, { SecondaryNav, WizardButton, WizardRail }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SecondaryNav, WizardButton, WizardRail }, script.__o.components);}